import { useEffect } from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import OurJourneyPage from "@/pages/OurJourney";
import Reviews from "@/pages/Reviews";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Partner from "@/pages/Partner";
import WhiteLabel from "@/pages/WhiteLabel";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import ShopifyAccountRedirect from "@/components/auth/ShopifyAccountRedirect";
import Account from "@/pages/Account";
import Checkout from "@/pages/Checkout";
import LegalPage from "@/pages/LegalPage";
import { privacy, cookie, terms, delivery } from "@/data/legal";
import NotFound from "@/pages/NotFound";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/our-journey" element={<OurJourneyPage />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/:slug" element={<GuideDetail />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/white-label" element={<WhiteLabel />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<Faq />} />
        {/* Customer accounts: native on-brand pages backed by Shopify Customer Account API */}
        <Route path="/login" element={<ShopifyAccountRedirect />} />
        <Route path="/account" element={<Account />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/privacy-policy" element={<LegalPage doc={privacy} />} />
        <Route path="/cookie-policy" element={<LegalPage doc={cookie} />} />
        <Route path="/terms-and-conditions" element={<LegalPage doc={terms} />} />
        <Route path="/delivery-return-policy" element={<LegalPage doc={delivery} />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "var(--acx-card)",
              border: "1px solid var(--acx-border)",
              color: "#fff",
            },
          }}
        />
      </CartProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
